module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.0.1-195.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.0.1.md
// module id = 638
// module chunks = 379